// extracted by mini-css-extract-plugin
export default {"sendCoins":"SendCoins_sendCoins__9QdBI","users":"SendCoins_users__aHq36","desc":"SendCoins_desc__SfeVm","input":"SendCoins_input__AhhJY"};